import Axios from 'axios';
import AxiosConfig from 'src/utilities/AxiosConfig';
import { DailyReviewSummary, DailyReviewSummaryRequestParams } from "../DailyReviewInterfaces";

const getDailyReviewSummaryData = async (profitCenter : number, date : Date) => {
    if (profitCenter == null || date == null) return;   

    const params : DailyReviewSummaryRequestParams = {
        profitCenterID: profitCenter,
        date: date
    };

    try {
        const response : any = await Axios.post(`${process.env.REACT_APP_API_URL}/api/DailyReview/getDailyReviewSummary`, params, AxiosConfig.configValue('min'));
        const dailyReviewSummaryResponse : DailyReviewSummary = {
            eightWeekTicketCounts: response.data.response.eightWeekTicketCounts,
            employeeSummaries: response.data.response.employeeSummaries,
            productionSummary: response.data.response.productionSummary,
            sevenDayTicketCounts: response.data.response.sevenDayTicketCounts,
            ticketCategoryCounts: response.data.response.ticketCategoryCounts,
            ticketTimeliness: response.data.response.ticketTimeliness,
            dlsCount: response.data.response.dlsCount,
            employeeEnteredHoursCount: response.data.response.employeeHours
        };
        dailyReviewSummaryResponse.employeeSummaries.sort((a, b) => a.EmployeeName < b.EmployeeName ? -1 : 1);

        return { success: true, response: dailyReviewSummaryResponse };
    }
    catch (error) {
        return { success: false, response: error }
    }   
};

export default getDailyReviewSummaryData;